import { mediaItems, appInfo, carouselItems, features, indexItems } from '@/mocks/homeData';

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            精彩视频
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精选影视内容
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            幕后花絮、观影指南、电影解析，精彩不止于正片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <a key={item.id} href="#cards" className="group bg-background-50 rounded-xl overflow-hidden block no-underline cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`四虎影视大全${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-primary-600 group-hover:text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 bg-black/70 rounded text-xs text-white font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <span className="inline-block text-xs font-semibold text-accent-400 uppercase tracking-wider bg-accent-500/15 px-3 py-1 rounded-full mb-4">
                移动观影
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                {appInfo.title}
              </h2>
              <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                {appInfo.description}
              </p>
              <div className="grid grid-cols-2 gap-3 max-w-sm mx-auto lg:mx-0 mb-6">
                {appInfo.features.map((f, i) => (
                  <div key={i} className="flex items-center gap-2 text-sm text-white/80">
                    <i className="ri-check-line text-accent-400 text-sm"></i>
                    <span className="whitespace-nowrap">{f}</span>
                  </div>
                ))}
              </div>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                立即体验
              </a>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-0">
              <div className="w-56 h-96 bg-background-100 rounded-3xl overflow-hidden border-4 border-white/10 relative">
                <div className="absolute top-0 left-0 right-0 h-8 bg-black/30 flex items-center justify-center">
                  <div className="w-16 h-1 bg-white/30 rounded-full"></div>
                </div>
                <div className="pt-10 px-4">
                  <div className="bg-background-200/50 rounded-lg p-2 mb-3 flex items-center gap-2">
                    <div className="w-8 h-8 rounded bg-primary-500/30 flex-shrink-0"><i className="ri-search-line text-primary-400 text-xs block text-center leading-8"></i></div>
                    <div className="flex-1 h-6 bg-background-300/50 rounded"></div>
                  </div>
                  <div className="space-y-2">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <div key={n} className="bg-background-200/50 rounded-lg h-16 flex items-center gap-2 p-2">
                        <div className="w-10 h-14 rounded bg-accent-500/20 flex-shrink-0"></div>
                        <div className="flex-1 space-y-1.5">
                          <div className="h-2.5 bg-background-300/50 rounded w-3/4"></div>
                          <div className="h-2 bg-background-300/50 rounded w-1/2"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            专题精选
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门专题一网打尽
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            精选四大专题，每个专题都为你甄选了不可错过的佳片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative rounded-xl overflow-hidden aspect-[16/9] block no-underline cursor-pointer"
            >
              <img
                src={item.image}
                alt={`四虎影视大全${item.title}`}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-accent-500 text-white rounded-md mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-white/80 leading-relaxed max-w-md">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            我们的优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            为什么选择四虎影视大全
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            三大核心优势，给你最纯粹的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-6 md:p-8 text-center">
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center bg-primary-100 rounded-2xl">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            影片索引
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            全部分类一览
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            按类型浏览四虎影视大全的全部影片资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {indexItems.map((group, gi) => (
            <div key={gi} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4 pb-3 border-b border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                  <span className="text-white font-bold text-lg font-heading">{group.letter}</span>
                </div>
                <span className="font-heading text-base font-bold text-foreground-900">
                  {group.letter}作分类
                </span>
              </div>
              <div className="space-y-2.5">
                {group.items.map((item, ii) => (
                  <a
                    key={ii}
                    href="#cards"
                    className="flex items-center justify-between py-1.5 hover:text-primary-600 transition-colors cursor-pointer no-underline"
                  >
                    <span className="text-sm text-foreground-700">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.count} 部</span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}